import { render, staticRenderFns } from "./TreeType.html?vue&type=template&id=0dd84171&scoped=true&external"
import script from "./TreeType.vue?vue&type=script&lang=js"
export * from "./TreeType.vue?vue&type=script&lang=js"
import style0 from "./TreeType.scss?vue&type=style&index=0&id=0dd84171&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd84171",
  null
  
)

export default component.exports